import axiosInstance from 'common/js/axios-service'

export const getMenuLists = () => {
  return axiosInstance.request({
    url: 'core/menu.json?pageSize=999',
    params: { switch: true }
  })
}
